<template>
  <v-card
    class="create-card elevation-3 ma-5"
    v-if="profile"
    :class="{ mobile: $vuetify.breakpoint.xs }"
    style="width: 100%"
  >
    <v-card-title class="d-flex flex-row align-center px-6 py-4">
      <editable-avatar
        :image="profile.thumbnail || profile.image"
        :editable="false"
        :size="$vuetify.breakpoint.xs ? 40 : 50"
        class="mr-4 avatar-pulse"
      />

      <v-btn
        v-text="`What's Happening ${truncateName(profile.name)} ?`"
        rounded
        v-if="profile.type === 'Agency'"
        class="text-none mx-2 flex-grow justify-start create-post-btn"
        outlined
        large
        :color="accentColor"
        @click="showDialog('')"
        height="48"
        :ripple="{ class: 'accent--text' }"
      >
        <template v-slot:prepend>
          <v-icon :color="accentColor" class="mr-2 post-icon"
            >mdi-pencil</v-icon
          >
        </template>
      </v-btn>

      <v-btn
        v-text="`What's Happening ${truncateFullName(profile.first_name, profile.last_name)} ?`"
        rounded
        v-if="profile.type === 'Volunteer'"
        class="text-none mx-2 flex-grow justify-start create-post-btn"
        outlined
        large
        :color="accentColor"
        @click="showDialog('')"
        height="48"
        :ripple="{ class: 'accent--text' }"
      >
        <template v-slot:prepend>
          <v-icon :color="accentColor" class="mr-2 post-icon"
            >mdi-pencil</v-icon
          >
        </template>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <create-event-dialog
      v-if="profile.status == 'Available'"
      :dialog="dialog"
      :onCloseDialog="onCloseDialog"
      :initalType="type"
    />

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="4000"
      elevation="24"
      rounded="pill"
      class="status-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon left :color="snackbarIconColor">{{ snackbarIcon }}</v-icon>
        {{ message }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
          :color="snackbarButtonColor"
        >
          Dismiss
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import EditableAvatar from "@/components/EditableAvatar.vue";
import CreateEventDialog from "./CreateEventDialog.vue";

export default {
  components: { EditableAvatar, CreateEventDialog },
  data() {
    return {
      loading: false,
      dialog: false,
      type: "",
      message: "",
      snackbar: false,
      showQuickActions: false,
      accentColor: "#3B7CA1",
      snackbarColor: "error",
      snackbarIcon: "mdi-alert-circle",
      snackbarIconColor: "white",
      snackbarButtonColor: "white",
      hoverActive: false
    };
  },
  computed: {
    ...mapState("auth", {
      profile: "profile"
    }),
    isProfilePending() {
      return (
        this.profile.status === "Pending" || this.profile.status === "Rejected"
      );
    }
  },
  methods: {
    showDialog(type) {
      if (this.isProfilePending) {
        this.message = "Please wait for admin approval before creating content";
        this.snackbarColor = "error";
        this.snackbarIcon = "mdi-alert-circle";
        this.snackbar = true;
        return;
      }
      this.dialog = true;
      this.type = type;
    },
    onCloseDialog() {
      this.dialog = false;
    },
    toggleQuickActions() {
      this.showQuickActions = !this.showQuickActions;
    },
      truncateName(name, length = 30) {
    if (!name) return '';
    return name.length > length ? name.slice(0, length) + '...' : name;
  },
    truncateFullName(first, last, length = 30) {
    const fullName = `${first || ''} ${last || ''}`.trim();
    return fullName.length > length ? fullName.slice(0, length) + '...' : fullName;
  },
  },
  mounted() {
    // Detect if device supports hover
    const isHoverDevice = window.matchMedia("(hover: hover)").matches;
    if (isHoverDevice) {
      const card = this.$el;
      card.addEventListener("mouseenter", () => {
        this.showQuickActions = true;
        this.hoverActive = true;
      });
      card.addEventListener("mouseleave", () => {
        this.showQuickActions = false;
        this.hoverActive = false;
      });
    } else {
      // For touch devices, show a toggle button or make it always visible
      this.showQuickActions = true;
    }
  }
};
</script>

<style scoped>
.create-card {
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.create-card:hover {
  box-shadow: 0 12px 28px rgba(59, 124, 161, 0.15) !important;
  transform: translateY(-2px);
}

.create-post-btn {
  border: 1px solid rgba(59, 124, 161, 0.4) !important;
  background-color: rgba(59, 124, 161, 0.05) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-weight: 500;
  letter-spacing: 0.5px;
}

.create-post-btn:hover {
  background-color: rgba(59, 124, 161, 0.1) !important;
  box-shadow: 0 4px 8px rgba(59, 124, 161, 0.15);
  transform: translateY(-1px);
}

.create-post-btn:hover .post-icon {
  transform: rotate(15deg);
}

.post-icon {
  transition: transform 0.3s ease;
}

.action-btn {
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin: 0 4px;
}

.action-btn:hover {
  background-color: rgba(59, 124, 161, 0.08) !important;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.btn-text {
  font-weight: 500;
  font-size: 0.9rem;
  margin-left: 4px;
  transition: color 0.2s ease;
}

.action-buttons {
  animation: fadeIn 0.3s ease-in-out;
}

.avatar-pulse {
  position: relative;
}

.avatar-pulse::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 0 0 rgba(59, 124, 161, 0.6);
  animation: pulse 2s infinite;
}

.status-snackbar {
  font-weight: 500;
}

/* Mobile optimizations */
.mobile .create-post-btn {
  height: 40px !important;
  font-size: 0.9rem;
}

.mobile .action-btn {
  padding: 6px 10px;
  min-width: 60px;
}

.mobile .btn-text {
  font-size: 0.75rem;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 124, 161, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(59, 124, 161, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 124, 161, 0);
  }
}

@media (max-width: 600px) {
  .action-btn {
    padding: 6px 8px;
    margin: 0 2px;
  }

  .btn-text {
    display: none;
  }

  .action-btn .v-icon {
    margin-right: 0 !important;
  }

  .create-card {
    border-radius: 12px !important;
  }
}
</style>
